import React, { useEffect, useState } from 'react';

import ReassignCarButton from '../../components/CreditApplications/ReassignCarButton';
import getDealCars from '../../api/deals/getDealCars';
import formatNumber from '../../utils/formatNumber';

const styles = {
  card: { background: '#fff', border: '1px solid #E7E7ED', borderRadius: 8, padding: 24, marginTop: 20 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, marginBottom: 20 },
  title: { fontWeight: 600, fontSize: 15 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px 24px' },
  label: { color: '#6A6A6A', fontSize: 12, lineHeight: '16px', marginBottom: 4 },
  value: { fontSize: 14, lineHeight: '20px', wordBreak: 'break-word' },
  note: { color: '#6A6A6A', fontSize: 13, marginBottom: 16 },
  warn: { background: '#FDEDED', border: '1px solid #EE7171', borderRadius: 8, padding: '10px 16px', marginBottom: 16 },
};

const Field = ({ label, value }) => (
  <div>
    <p style={styles.label}>{label}</p>
    <p style={styles.value}>{value || '—'}</p>
  </div>
);

/**
 * Автомобиль лида — в «Основной информации», чтобы менеджер видел его сразу. Пока
 * сделки нет, машина известна из лида (клиент положил её в корзину); после
 * конвертации — машина активной сделки, её можно заменить.
 */
const LeadCarCard = ({ lead, onChanged }) => {
  const [dealCar, setDealCar] = useState(null);
  const activeDealId = lead?.deals?.[0]?.id;

  const loadDealCar = () => {
    if (!activeDealId) {
      setDealCar(null);
      return Promise.resolve();
    }
    return getDealCars({ id: activeDealId })
      .then((res) => setDealCar(res.data?.cars?.[0] || null))
      .catch(() => setDealCar(null));
  };

  useEffect(() => {
    loadDealCar();
  }, [activeDealId]);

  const leadCar = lead?.car;
  const car = dealCar
    ? {
        mark: dealCar.mark,
        model: dealCar.model,
        complectation: dealCar.complectation?.title || dealCar.complectation?.name,
        color: dealCar.color,
        issueYear: dealCar.issueYear,
        vin: dealCar.vin,
        city: dealCar.city?.title,
        engine_volume: dealCar.engine_volume,
        price: dealCar.price,
      }
    : leadCar;

  if (!car) return null;

  const carReleased = !!dealCar?.stockReturnedAt;

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <p style={styles.title}>{dealCar ? 'Автомобиль в сделке' : 'Автомобиль, выбранный клиентом'}</p>
        {dealCar && (
          <ReassignCarButton
            orderId={dealCar.orderId}
            complectationId={dealCar.complectationId}
            color={dealCar.color}
            onDone={() => loadDealCar().then(() => onChanged && onChanged())}
          />
        )}
      </div>

      {carReleased && <div style={styles.warn}>Эта машина уже не закреплена за сделкой. Подберите другую.</div>}
      {/* Машину почти всегда держит сам клиент — это нормально, а не повод пугать менеджера. */}
      {!dealCar && leadCar?.reservedByClient && <p style={styles.note}>Автомобиль находится в корзине клиента.</p>}

      <div style={{ ...styles.grid, opacity: carReleased ? 0.5 : 1 }}>
        <Field label="Марка и модель" value={[car.mark, car.model].filter(Boolean).join(' ')} />
        <Field label="Комплектация" value={car.complectation} />
        <Field label="Цвет" value={car.color} />
        <Field label="Год выпуска" value={car.issueYear} />
        <Field label="VIN" value={car.vin} />
        <Field label="Город" value={car.city} />
        <Field label="Двигатель" value={car.engine_volume ? `${car.engine_volume} см³` : null} />
        <Field label="Цена" value={car.price ? `${formatNumber(car.price)} ₸` : null} />
      </div>
    </div>
  );
};

export default LeadCarCard;
